var RobotError;
(function (RobotError) {
    RobotError["CURRENT_CUSTOMER_REQUIRED"] = "CURRENT_CUSTOMER_REQUIRED";
    RobotError["INVALID_CURRENT_CUSTOMER"] = "INVALID_CURRENT_CUSTOMER";
    RobotError["INVALID_NAME"] = "INVALID_NAME";
    RobotError["NAME_REQUIRED"] = "NAME_REQUIRED";
    RobotError["NAME_MIN_LENGTH"] = "NAME_MIN_LENGTH";
    RobotError["ROBOT_REQUIRED"] = "ROBOT_REQUIRED";
    RobotError["INVALID_ROBOT"] = "INVALID_ROBOT";
    RobotError["ROBOT_NOT_FOUND"] = "ROBOT_NOT_FOUND";
    RobotError["CUSTOMER_REQUIRED"] = "CUSTOMER_REQUIRED";
    RobotError["ACTIVE_REQUIRED"] = "ACTIVE_REQUIRED";
    RobotError["INVALID_ACTIVE"] = "INVALID_ACTIVE";
    RobotError["INVALID_INSTANCE"] = "INVALID_INSTANCE";
    RobotError["INSTANCE_REQUIRED"] = "INSTANCE_REQUIRED";
    RobotError["INSTANCE_NOT_FOUND"] = "INSTANCE_NOT_FOUND";
    RobotError["RUN_REQUIRED"] = "RUN_REQUIRED";
    RobotError["INVALID_RUN"] = "INVALID_RUN";
    RobotError["ROBOT_INSTANCE_REQUIRED"] = "ROBOT_INSTANCE_REQUIRED";
    RobotError["INVALID_ROBOT_INSTANCE"] = "INVALID_ROBOT_INSTANCE";
    RobotError["FINISHED_REQUIRED"] = "FINISHED_REQUIRED";
    RobotError["INVALID_FINISHED"] = "INVALID_FINISHED";
    RobotError["SUCCESS_REQUIRED"] = "SUCCESS_REQUIRED";
    RobotError["INVALID_SUCCESS"] = "INVALID_SUCCESS";
    RobotError["OUTPUT_REQUIRED"] = "OUTPUT_REQUIRED";
    RobotError["INVALID_OUTPUT"] = "INVALID_OUTPUT";
    RobotError["ROBOT_INSTANCE_NOT_FOUND"] = "ROBOT_INSTANCE_NOT_FOUND";
    RobotError["INVALID_LOADRUNS"] = "INVALID_LOADRUNS";
    RobotError["INVALID_LOADDEVICES"] = "INVALID_LOADDEVICES";
    RobotError["DURATION_REQUIRED"] = "DURATION_REQUIRED";
    RobotError["INVALID_DURATION"] = "INVALID_DURATION";
    RobotError["SCHEDULEMODE_REQUIRED"] = "SCHEDULEMODE_REQUIRED";
    RobotError["INVALID_SCHEDULEMODE"] = "INVALID_SCHEDULEMODE";
    RobotError["INVALID_WEEKDAYS"] = "INVALID_WEEKDAYS";
    RobotError["INVALID_MONTHDAYS"] = "INVALID_MONTHDAYS";
    RobotError["INVALID_SPECIFICDATES"] = "INVALID_SPECIFICDATES";
    RobotError["TIMEMODE_REQUIRED"] = "TIMEMODE_REQUIRED";
    RobotError["INVALID_TIMEMODE"] = "INVALID_TIMEMODE";
    RobotError["TIMEPERIOD_MIN_SIZE_INVALID"] = "TIMEPERIOD_MIN_SIZE_INVALID";
    RobotError["INVALID_TIMEPERIOD"] = "INVALID_TIMEPERIOD";
    RobotError["INVALID_TIMEINTERVAL"] = "INVALID_TIMEINTERVAL";
    RobotError["INVALID_SPECIFICTIMES"] = "INVALID_SPECIFICTIMES";
    RobotError["DURATION_MIN_SIZE_INVALID"] = "DURATION_MIN_SIZE_INVALID";
    RobotError["SCHEDULE_REQUIRED"] = "SCHEDULE_REQUIRED";
    RobotError["INVALID_SCHEDULE"] = "INVALID_SCHEDULE";
    RobotError["FREQUENCY_OF_USE_REQUIRED"] = "FREQUENCY_OF_USE_REQUIRED";
    RobotError["INVALID_FREQUENCY_OF_USE"] = "INVALID_FREQUENCY_OF_USE";
    RobotError["RUNTIME_REQUIRED"] = "RUNTIME_REQUIRED";
    RobotError["INVALID_RUNTIME"] = "INVALID_RUNTIME";
    RobotError["N_OF_PEOPLE_IN_PROCESS_REQUIRED"] = "N_OF_PEOPLE_IN_PROCESS_REQUIRED";
    RobotError["INVALID_N_OF_PEOPLE_IN_PROCESS"] = "INVALID_N_OF_PEOPLE_IN_PROCESS";
    RobotError["INVALID_SUCCESS_INDICATOR"] = "INVALID_SUCCESS_INDICATOR";
    RobotError["SUCCESS_INDICATOR_REQUIRED"] = "SUCCESS_INDICATOR_REQUIRED";
    RobotError["INVALID_REMOTE_ACCESS"] = "INVALID_REMOTE_ACCESS";
    RobotError["INVALID_SYSTEM_ACCESS"] = "INVALID_SYSTEM_ACCESS";
    RobotError["TRIGGER_TYPE_REQUIRED"] = "TRIGGER_TYPE_REQUIRED";
    RobotError["INVALID_TRIGGER_TYPE"] = "INVALID_TRIGGER_TYPE";
    RobotError["INVALID_REQUEST_STATUS"] = "INVALID_REQUEST_STATUS";
    RobotError["STATUS_REQUIRED"] = "STATUS_REQUIRED";
    RobotError["KIND_REQUIRED"] = "KIND_REQUIRED";
    RobotError["INVALID_KIND"] = "INVALID_KIND";
    RobotError["TIMEZONE_REQUIRED"] = "TIMEZONE_REQUIRED";
    RobotError["INVALID_TIMEZONE"] = "INVALID_TIMEZONE";
    RobotError["TIMEZONE_NAME_REQUIRED"] = "TIMEZONE_NAME_REQUIRED";
    RobotError["INVALID_TIMEZONE_NAME"] = "INVALID_TIMEZONE_NAME";
    RobotError["TIMEZONE_OFFSET_REQUIRED"] = "TIMEZONE_OFFSET_REQUIRED";
    RobotError["INVALID_TIMEZONE_OFFSET"] = "INVALID_TIMEZONE_OFFSET";
})(RobotError || (RobotError = {}));
export default RobotError;
